import styled from 'styled-components';
import logo from '@/assets/images/happy-hearts-logo.svg';
import {
  HAPPY_HEARTS_FOOTER_LINKS,
  HAPPY_HEARTS_SITE_URL,
  HAPPY_HEARTS_SUPPORT_NUMBER,
  HAPPY_HEARTS_SUPPORT_TEL,
} from '@/components/happyHeartsSite';

const Footer = styled.footer`
  width: 100%;
  padding: 48px 4%;
  background: #23201c;
  color: rgba(255, 255, 255, 0.68);
  font-family: var(--font-ui, 'Lato', sans-serif);
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

const Top = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
`;

const LogoLink = styled.a`
  display: inline-flex;
  flex-shrink: 0;
  border-radius: 4px;
`;

const Logo = styled.img`
  display: block;
  width: auto;
  height: 28px;
  opacity: 0.75;
  filter: brightness(0) invert(1);
`;

const Links = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 26px;
  font-size: 14px;
  line-height: 1.5;

  a {
    color: rgba(255, 255, 255, 0.68);
    text-decoration: none;
    white-space: normal;
    transition: color 0.18s ease;
  }

  a:hover,
  a:focus-visible {
    color: #fff;
  }
`;

const Support = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 26px;
  font-size: 14px;

  a {
    color: rgba(255, 255, 255, 0.68);
    text-decoration: none;
  }

  a:hover,
  a:focus-visible {
    color: #fff;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

const Disclaimer = styled.p`
  margin: 0;
  padding-top: 22px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  line-height: 1.65;
  white-space: normal;
`;

const HappyHeartsFooter = () => (
  <Footer>
    <Inner>
      <Top>
        <LogoLink href={HAPPY_HEARTS_SITE_URL} aria-label="Happy Hearts home">
          <Logo src={logo} alt="" width="140" height="28" />
        </LogoLink>
        <Links aria-label="Happy Hearts website links">
          {HAPPY_HEARTS_FOOTER_LINKS.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </Links>
      </Top>
      <Support aria-label="Happy Hearts support">
        <a href={`tel:${HAPPY_HEARTS_SUPPORT_TEL}`}>Call support: {HAPPY_HEARTS_SUPPORT_NUMBER}</a>
        <a href="mailto:support@happyhearts.com">Email support</a>
      </Support>
      <Disclaimer>
        Happy Heart Care Services, LLC is a heart health service available to eligible adults on
        Original Medicare. It takes part in a Medicare program called the ACCESS Model. Availability
        varies by location and ACCESS eligibility. Happy Hearts complements, not replaces, the care
        you receive from your own doctor. It is not an emergency service. If you think you are having
        a medical emergency, call your doctor or 911. Happy Hearts is not Medicare, CMS, or a
        government agency, and Medicare does not endorse specific ACCESS participants. “No cost”
        means Happy Hearts does not charge eligible Original Medicare beneficiaries for ACCESS
        services when they enroll with Happy Hearts.
      </Disclaimer>
    </Inner>
  </Footer>
);

export { HappyHeartsFooter };